module.exports = __webpack_public_path__ + "img/close-photo.09df21b3.svg";